const params = new URLSearchParams(window.location.search);

/* Utilities */
window.Cookies = require('js-cookie');

import EHIStore from './store/EHIStore';
window.EHIStore = new EHIStore();

/* Polyfills */
Number.isFinite = Number.isFinite ?? require('./polyfills/is-finite.js');
Number.isInteger = Number.isInteger ?? require('./polyfills/is-integer.js');

/* Campaign attribution */
import { PersistentParameters } from './components/persistent-parameters.js';
(new PersistentParameters()).init();

/* Helpers */
import {BrowserEngineDetect} from './helpers/browser-engine-detect';
BrowserEngineDetect();

import {UserAgentParser} from './helpers/user-agent-parser';
window.UserAgentParser = new UserAgentParser();

import {ZoomDetector} from './helpers/zoom-detector.js';
new ZoomDetector();

require('./helpers/query-string-parameters.js');
require('./helpers/breakpoints.js');
require('./helpers/force-checked.js');


/* Components */
require('./components/href-zipcode.js');
require('./components/iframe-break.js');
// const MutationObserver = new (require('./components/mutation-observer.js'));
const SiteHeader = new (require('./components/site-header.js'));
require('./components/tooltips.js');

import { LinkConfirmation } from './components/link-confirmation.js';

if (params.get('fl_builder') == null) {
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', (event) => { return new LinkConfirmation(); });
    } else {
        document.body.addEventListener('click', (event) => { return new LinkConfirmation(); });
    }
}

import { HashScroller } from './components/hash-scroller.js';
new HashScroller({headerSelector: 'header#header--site'});

require('./components/to-top.js');
require('./components/toc.js');
require('./components/lumeris-combobox.js');
require('./components/lumeris-documents/lumeris-documents.js');
require('./components/equal-dimensions.js');
require('./components/explicit-dimensions.js');
require('./components/unlazyload.js');

import { AnalyticsEvents } from './components/analytics-events.js';
new AnalyticsEvents();


/* Templates */
import { Header } from './templates/header.js';
document.addEventListener('DOMContentLoaded', (event) => { return new Header(); });
